module.exports = __webpack_public_path__ + "static/media/group.ebe91d22.svg";